// // client/src/components/admin/AddAssetModal.js
// import React from 'react';
// import { FileSpreadsheet } from 'lucide-react';
// import './modals.css'
// function AddAssetModal({
//   newAssetData,
//   setNewAssetData,
//   handleAddAsset,
//   setShowAddAssetModal,
// }) {
//   const handleSimCardChange = (key, value) => {
//     setNewAssetData(prev => ({
//       ...prev,
//       simCard: {
//         ...prev.simCard,
//         [key]: value,
//       },
//     }));
//   };

//   return (
//     <div className="modal-overlay">
//       <div className="modal-content">
//         <h3 className="text-xl font-semibold mb-4 text-gray-800">
//           <FileSpreadsheet size={20} className="inline mr-2" /> Add New Asset
//         </h3>
//         <form onSubmit={handleAddAsset}>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             {/* Device Details */}
//             <h4 className="col-span-full mb-3 text-lg font-medium border-b pb-1">Device Details</h4>
            
//             <div className="form-group">
//               <label htmlFor="assetIMEI">IMEI</label>
//               <input type="text" id="assetIMEI" className="input-field"
//                 value={newAssetData.IMEI}
//                 onChange={(e) => setNewAssetData({ ...newAssetData, IMEI: e.target.value.replace(/[^0-9]/g, "") })}
//                 required maxLength="15"
//               />
//             </div>
//             <div className="form-group">
//               <label htmlFor="assetSerialNumber">Serial Number (Optional)</label>
//               <input type="text" id="assetSerialNumber" maxLength="15" className="input-field"
//                 value={newAssetData.serialNumber}
//                 onChange={(e) => setNewAssetData({ ...newAssetData, serialNumber: e.target.value })}
//               />
//             </div>
            
//             <div className="form-group">
//               <label htmlFor="assetModel">Model</label>
//               <select id="assetModel" required className="input-field"
//                 value={newAssetData.model}
//                 onChange={(e) => setNewAssetData({ ...newAssetData, model: e.target.value })}
//               >
//                 <option value="">-- Select Model --</option>
//                 {['GT06', 'GT06N', 'GT06E', 'GV20', 'GV300', 'FMB920', 'FMB120', 'Other'].map(m => <option key={m} value={m}>{m}</option>)}
//               </select>
//               {newAssetData.model === "Other" && (
//                 <input type="text" id="customModel" placeholder="Enter custom model" className="input-field mt-2"
//                   value={newAssetData.customModel || ""}
//                   onChange={(e) => setNewAssetData({ ...newAssetData, customModel: e.target.value })}
//                 />
//               )}
//             </div>

//             <div className="form-group">
//               <label htmlFor="assetType">Device Type</label>
//               <select id="assetType" className="input-field"
//                 value={newAssetData.type}
//                 onChange={(e) => setNewAssetData({ ...newAssetData, type: e.target.value })}
//               >
//                 <option value="hardwire">Hardwire</option>
//                 <option value="portable">Portable</option>
//                 <option value="OBD">OBD</option>
//                 <option value="other">Other</option>
//               </select>
//             </div>

//             <div className="form-group col-span-full">
//               <label htmlFor="devPurchaseDate">Device Purchase Date (Optional)</label>
//               <input type="date" id="devPurchaseDate" className="input-field"
//                 value={newAssetData.purchaseDate}
//                 onChange={(e) => setNewAssetData({ ...newAssetData, purchaseDate: e.target.value })}
//               />
//             </div>

//             {/* SIM Details */}
//             <h4 className="col-span-full mb-3 text-lg font-medium border-b pb-1 mt-4">SIM Details</h4>

//             <div className="form-group">
//               <label htmlFor="simIMSI">IMSI (Optional)</label>
//               <input type="text" id="simIMSI" className="input-field"
//                 value={newAssetData.simCard.IMSI || ""}
//                 onChange={(e) => handleSimCardChange('IMSI', e.target.value.replace(/[^0-9]/g, ""))}
//                 maxLength="15"
//               />
//             </div>
//             <div className="form-group">
//               <label htmlFor="simMSDN">MSDN (Optional)</label>
//               <input type="text" id="simMSDN" maxLength="13" className="input-field"
//                 value={newAssetData.simCard.MSDN || ""}
//                 onChange={(e) => handleSimCardChange('MSDN', e.target.value.replace(/[^0-9]/g, ""))}
//               />
//             </div>
//             <div className="form-group">
//               <label htmlFor="simProvider">Provider (Optional)</label>
//               <select id="simProvider" className="input-field"
//                 value={newAssetData.simCard.provider}
//                 onChange={(e) => handleSimCardChange('provider', e.target.value)}
//               >
//                 <option value="">-- Select Provider --</option>
//                 {['Jio', 'Airtel', 'Vi', 'BSNL', 'MTNL'].map(p => <option key={p} value={p}>{p}</option>)}
//               </select>
//             </div>
//             <div className="form-group">
//               <label htmlFor="simExpiryDate">Expiry Date (Optional)</label>
//               <input type="date" id="simExpiryDate" className="input-field"
//                 value={newAssetData.simCard.expiryDate}
//                 onChange={(e) => handleSimCardChange('expiryDate', e.target.value)}
//               />
//             </div>

//             {/* Notes */}
//             <div className="form-group col-span-full">
//               <label htmlFor="assetNotes">Notes (Optional)</label>
//               <textarea id="assetNotes" className="input-field" rows="2" maxLength={100}
//                 value={newAssetData.notes}
//                 onChange={(e) => setNewAssetData({ ...newAssetData, notes: e.target.value })}
//               />
//             </div>
//           </div>

//           <div className="button-group-center mt-6">
//             <button type="submit" className="btn-primary">Add Asset</button>
//             <button type="button" className="btn-secondary" onClick={() => setShowAddAssetModal(false)}>Cancel</button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default AddAssetModal;
// client/src/components/admin/AddAssetModal.js

import React, { useState } from 'react';
import { FileSpreadsheet, AlertCircle, CheckCircle, Loader2 } from 'lucide-react';
import './modals.css';

function AddAssetModal({
  newAssetData,
  setNewAssetData,
  handleAddAsset,
  setShowAddAssetModal,
}) {
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSimCardChange = (key, value) => {
    setNewAssetData(prev => ({
      ...prev,
      simCard: {
        ...prev.simCard,
        [key]: value,
      },
    }));
    // Clear error when user types
    if (errors[`simCard.${key}`]) {
      setErrors(prev => ({ ...prev, [`simCard.${key}`]: null }));
    }
  };

  const handleFieldChange = (field, value) => {
    setNewAssetData(prev => ({ ...prev, [field]: value }));
    // Clear error when user types
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  // 🎯 Validation function
  const validateForm = () => {
    const newErrors = {};

    // IMEI validation
    if (!newAssetData.IMEI) {
      newErrors.IMEI = "IMEI is required";
    } else if (newAssetData.IMEI.length !== 15) {
      newErrors.IMEI = `IMEI must be 15 digits (currently ${newAssetData.IMEI.length})`;
    }

    // Model validation
    if (!newAssetData.model) {
      newErrors.model = "Please select a model";
    }

    // Custom model validation
    if (newAssetData.model === "Other" && !newAssetData.customModel?.trim()) {
      newErrors.customModel = "Please enter custom model name";
    }

    // IMSI validation (optional but if entered, must be valid)
    if (newAssetData.simCard?.IMSI && newAssetData.simCard.IMSI.length !== 15) {
      newErrors['simCard.IMSI'] = `IMSI must be 15 digits (currently ${newAssetData.simCard.IMSI.length})`;
    }

    // MSDN validation (optional but if entered, must be valid)
    if (newAssetData.simCard?.MSDN && (newAssetData.simCard.MSDN.length < 10 || newAssetData.simCard.MSDN.length > 13)) {
      newErrors['simCard.MSDN'] = "MSDN must be 10-13 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 🎯 Submit handler with validation
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    try {
      await handleAddAsset(e);
    } catch (err) {
      console.error("Add Asset Error:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  // 🎯 Helper to show field error
  const FieldError = ({ field }) => {
    if (!errors[field]) return null;
    return (
      <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
        <AlertCircle size={12} /> {errors[field]}
      </p>
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="text-xl font-semibold mb-4 text-gray-800">
          <FileSpreadsheet size={20} className="inline mr-2" /> Add New Asset
        </h3>

        {/* 🎯 Error Summary (if multiple errors) */}
        {Object.keys(errors).length > 0 && (
          <div style={{
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '6px',
            padding: '12px',
            marginBottom: '16px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#991b1b' }}>
              <AlertCircle size={18} />
              <span style={{ fontWeight: '600' }}>Please fix the following errors:</span>
            </div>
            <ul style={{ margin: '8px 0 0 24px', fontSize: '13px', color: '#b91c1c' }}>
              {Object.values(errors).filter(Boolean).map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            
            {/* Device Details Header */}
            <h4 className="col-span-full mb-3 text-lg font-medium border-b pb-1">Device Details</h4>

            {/* IMEI */}
            <div className="form-group">
              <label htmlFor="assetIMEI">
                IMEI <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type="text"
                id="assetIMEI"
                className="input-field"
                style={{ borderColor: errors.IMEI ? '#ef4444' : undefined }}
                value={newAssetData.IMEI}
                onChange={(e) => handleFieldChange('IMEI', e.target.value.replace(/[^0-9]/g, ""))}
                required
                maxLength="15"
                placeholder="Enter 15 digit IMEI"
              />
              <p style={{ color: '#6b7280', fontSize: '11px', marginTop: '2px' }}>
                {newAssetData.IMEI?.length || 0}/15 digits
              </p>
              <FieldError field="IMEI" />
            </div>

            {/* Serial Number */}
            <div className="form-group">
              <label htmlFor="assetSerialNumber">Serial Number (Optional)</label>
              <input
                type="text"
                id="assetSerialNumber"
                maxLength="15"
                className="input-field"
                value={newAssetData.serialNumber}
                onChange={(e) => handleFieldChange('serialNumber', e.target.value)}
                placeholder="Device serial number"
              />
            </div>

            {/* Model */}
            <div className="form-group">
              <label htmlFor="assetModel">
                Model <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <select
                id="assetModel"
                required
                className="input-field"
                style={{ borderColor: errors.model ? '#ef4444' : undefined }}
                value={newAssetData.model}
                onChange={(e) => handleFieldChange('model', e.target.value)}
              >
                <option value="">-- Select Model --</option>
                {['GT06', 'GT06N', 'GT06E', 'GV20', 'GV300', 'FMB920', 'FMB120', 'Other'].map(m => (
                  <option key={m} value={m}>{m}</option>
                ))}
              </select>
              <FieldError field="model" />
              
              {newAssetData.model === "Other" && (
                <>
                  <input
                    type="text"
                    id="customModel"
                    placeholder="Enter custom model name"
                    className="input-field mt-2"
                    style={{ borderColor: errors.customModel ? '#ef4444' : undefined }}
                    value={newAssetData.customModel || ""}
                    onChange={(e) => handleFieldChange('customModel', e.target.value)}
                  />
                  <FieldError field="customModel" />
                </>
              )}
            </div>

            {/* Device Type */}
            <div className="form-group">
              <label htmlFor="assetType">Device Type</label>
              <select
                id="assetType"
                className="input-field"
                value={newAssetData.type}
                onChange={(e) => handleFieldChange('type', e.target.value)}
              >
                <option value="hardwire">Hardwire</option>
                <option value="portable">Portable</option>
                <option value="OBD">OBD</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* Purchase Date */}
            <div className="form-group col-span-full">
              <label htmlFor="devPurchaseDate">Device Purchase Date (Optional)</label>
              <input
                type="date"
                id="devPurchaseDate"
                className="input-field"
                value={newAssetData.purchaseDate}
                onChange={(e) => handleFieldChange('purchaseDate', e.target.value)}
              />
            </div>

            {/* SIM Details Header */}
            <h4 className="col-span-full mb-3 text-lg font-medium border-b pb-1 mt-4">
              SIM Details
              <span style={{ fontSize: '12px', fontWeight: 'normal', color: '#6b7280', marginLeft: '8px' }}>
                (SIM Details (Optional – auto-filled after device comes online))
              </span>
            </h4>

            {/* IMSI */}
            <div className="form-group">
              <label htmlFor="simIMSI">IMSI (Optional)</label>
              <input
                type="text"
                id="simIMSI"
                className="input-field"
                style={{ borderColor: errors['simCard.IMSI'] ? '#ef4444' : undefined }}
                value={newAssetData.simCard?.IMSI || ""}
                onChange={(e) => handleSimCardChange('IMSI', e.target.value.replace(/[^0-9]/g, ""))}
                maxLength="15"
                placeholder="15 digit IMSI"
              />
              {newAssetData.simCard?.IMSI && (
                <p style={{ color: '#6b7280', fontSize: '11px', marginTop: '2px' }}>
                  {newAssetData.simCard.IMSI.length}/15 digits
                </p>
              )}
              <FieldError field="simCard.IMSI" />
            </div>

            {/* MSDN */}
            <div className="form-group">
              <label htmlFor="simMSDN">MSDN / SIM Number (Optional)</label>
              <input
                type="text"
                id="simMSDN"
                maxLength="13"
                className="input-field"
                style={{ borderColor: errors['simCard.MSDN'] ? '#ef4444' : undefined }}
                value={newAssetData.simCard?.MSDN || ""}
                onChange={(e) => handleSimCardChange('MSDN', e.target.value.replace(/[^0-9]/g, ""))}
                placeholder="10-13 digit SIM number"
              />
              <FieldError field="simCard.MSDN" />
            </div>

            {/* Provider */}
            <div className="form-group">
              <label htmlFor="simProvider">Provider (Optional)</label>
              <select
                id="simProvider"
                className="input-field"
                value={newAssetData.simCard?.provider || ""}
                onChange={(e) => handleSimCardChange('provider', e.target.value)}
              >
                <option value="">-- Select Provider --</option>
                {['Jio', 'Airtel', 'Vi', 'BSNL', 'MTNL'].map(p => (
                  <option key={p} value={p}>{p}</option>
                ))}
              </select>
            </div>

            {/* SIM Expiry */}
            <div className="form-group">
              <label htmlFor="simExpiryDate">SIM Expiry Date (Optional)</label>
              <input
                type="date"
                id="simExpiryDate"
                className="input-field"
                value={newAssetData.simCard?.expiryDate || ""}
                onChange={(e) => handleSimCardChange('expiryDate', e.target.value)}
              />
            </div>

            {/* Notes */}
            <div className="form-group col-span-full">
              <label htmlFor="assetNotes">Notes (Optional)</label>
              <textarea
                id="assetNotes"
                className="input-field"
                rows="2"
                maxLength={100}
                value={newAssetData.notes}
                onChange={(e) => handleFieldChange('notes', e.target.value)}
                placeholder="Any additional notes..."
              />
              <p style={{ color: '#6b7280', fontSize: '11px', marginTop: '2px', textAlign: 'right' }}>
                {newAssetData.notes?.length || 0}/100 characters
              </p>
            </div>
          </div>

          {/* Info Box */}
          <div style={{
            background: '#eff6ff',
            border: '1px solid #bfdbfe',
            borderRadius: '6px',
            padding: '12px',
            marginTop: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <CheckCircle size={18} color="#2563eb" />
            <span style={{ fontSize: '13px', color: '#1e40af' }}>
              After adding asset, use IMEI to add device.SIM details may auto-fill after IMEI validation or when device sends first data.
            </span>
          </div>

          {/* Buttons */}
          <div className="button-group-center mt-6">
            <button
              type="submit"
              className="btn-primary"
              disabled={isSubmitting}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                opacity: isSubmitting ? 0.7 : 1
              }}
            >
              {isSubmitting ? (
                <>
                  <Loader2 size={18} className="animate-spin" /> Adding...
                </>
              ) : (
                'Add Asset'
              )}
            </button>
            <button
              type="button"
              className="btn-secondary"
              onClick={() => setShowAddAssetModal(false)}
              disabled={isSubmitting}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddAssetModal;